<template>
  <div class="contractAdd">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-title">主体信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">乙方：</span>
          </div>
          <el-input v-model="formData.leaseName" size="small" style="width: 220px"  />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁地址：</span>
          </div>
          <el-input v-model="formData.address" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">租赁面积：</span>
          </div>
          <el-input v-model="formData.roomInfoArea" size="small" style="width: 220px">
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div style="width: 80px"></div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人：</span>
          </div>
          <el-input v-model="formData.signerName" size="small" style="width: 220px"  />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人手机：</span>
          </div>
          <el-input v-model="formData.signerPhone" size="small" style="width: 220px"  />
        </div>
        <div></div>
        <div style="width: 80px"></div>
      </div>

      <div class="form-title">合同信息</div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同编号：</span>
          </div>
          <el-input
            v-model="formData.code"
            disabled
            size="small"
            style="width: 220px"
          />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同类型：</span>
          </div>
          <el-select v-model="formData.type" placeholder="请选择" size="small" style="width: 220px">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同开始时间：</span>
          </div>
          <el-date-picker v-model="formData.contractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
        </div>
        <div style="width: 80px"></div>
      </div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同结束时间：</span>
          </div>
          <el-date-picker v-model="formData.contractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small"></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同签订时间：</span>
          </div>
          <el-date-picker v-model="formData.contractSignDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">提前付款天数：</span>
          </div>
          <el-input v-model="formData.propertyAheadPayDays" size="small" style="width: 220px">
            <template slot="append">天</template>
          </el-input>
        </div>
        <div style="width: 80px"></div>
      </div>

      <div class="form-title">账单信息</div>
      <div v-for="(item, index) in formData.otherPayItemDetails">
        <div class="form-line">
          <div>
            <div class="textBox">
              <span class="line-text">账单类型：</span>
            </div>
            <select-with-operation v-model="item.billType" :selectValue="item.billTypeCode" style="width: 220px" :optionList="billTypeList" addTip="添加账单类型" deleteTipInfo="是否确认删除该账单类型？" @addOption="wantAddBillType" @deleteOption="deleteBillType" @changeSelectValue="changeBillType(item,$event)" />
<!--            <el-select v-model="item.billType" placeholder="请选择" size="small" style="width: 220px">
              <el-option
                v-for="billType in billTypeList"
                :key="billType.name"
                :label="billType.name"
                :value="billType.name">
              </el-option>
            </el-select>-->
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单开始时间：</span>
            </div>
            <el-date-picker v-model="item.billStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单结束时间：</span>
            </div>
            <el-date-picker v-model="item.billEndTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small"></el-date-picker>
          </div>
        </div>
        <div class="form-line">
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">金额：</span>
            </div>
            <el-input v-model="item.payMoney" type="number" size="small" style="width: 220px;vertical-align: top;" v-on:blur="otherItemValueChange(index)">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addOtherItemLine()" v-if="index === formData.otherPayItemDetails.length - 1"></i>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeOtherItemLine(index)" v-if="index > 0"></i>
          </div>
          <div></div>
        </div>

      </div>

      <div class="form-title">
        附件管理
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">请上传pdf文件</div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-upload ref="uploadContract" :action="uploadAction" :headers="uploadHeaders" :on-success="uploadContractSuccess" :on-error="uploadContractError" :limit="1" style="display: inline-block;margin-left: 10px;" accept=".pdf">
          <span style="color: #00a0e6;cursor: pointer;font-size: 14px">上传</span>
        </el-upload>
      </div>
      <div class="form-line" v-for="(enclosure, enclosureIndex) in formData.attachmentList" v-if="formData.attachmentList.length > 0">
        <div>
          <div class="textBox">
            <span class="line-text">附件{{enclosureIndex + 1}}：</span>
          </div>
          <span style="color: #00a0e6;cursor: pointer;margin-right: 10px;" @click="previewFile(enclosure)">查看</span>
          <span style="color: #f25721;cursor: pointer;margin-right: 10px;" @click="deleteAttachmentItem(enclosureIndex)">删除</span>
        </div>
      </div>
      <div class="form-line" v-if="formData.attachmentList.length === 0">
        <div>
          <div class="textBox">
            <span class="line-text"></span>
          </div>
          <span style="color: #999999;">暂无附件</span>
        </div>
      </div>

      <div class="form-title">其他</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同跟进人：</span>
          </div>
          <el-select v-model="formData.fellowPeopleCode" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in yqPersonList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <!--<b class="red">*</b>-->
            <span class="line-text">客户来源：</span>
          </div>
          <el-select v-model="formData.customSource" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in customSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <!--            <b class="red">*</b>-->
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="formData.memo" size="small" style="width: 220px;vertical-align: top;" />
        </div>
        <div style="width: 80px"></div>
      </div>


      <div class="form-btn-box" style="margin: 20px auto 0;">
        <button-confirm @confirm="confirm" value="保存" />
        <button-confirm-next @confirm="confirmAndApproval" value="保存 & 审批" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>


    <div class="approveDialogBox">
      <el-dialog title="合同审批" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">合同摘要</div>
            <el-input type="textarea" :rows="4" placeholder="请输入合同摘要" v-model="digest" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmApprove">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="添加账单类型" :visible.sync="addBillTypeVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">类型名称：</span>
          </div>
          <el-input v-model="billTypeName" size="small" style="width: 280px" placeholder="请输入类型名称" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addBillTypeVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addBillType" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../utils/errorHandler'
import {api} from '../../api/InvestmentLeasing'
import {nError, nSuccess} from '../../../utils/notice'
import {treeApi} from '../../api/TreeApi'
import {bus} from '../../../utils/bus'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import InputTree from '../../../components/common/inputs/input-tree'
import SelectWithOperation from "../../../components/Select/SelectWithOperation";

export default {
  components: {
    InputTree,
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb,
    SelectWithOperation
  },
  name: 'other-contract-modify',
  data () {
    return {
      breadcrumb: [{
        value: '其他合约',
        name: 'other-custom-management'
      }, {
        value: '合同列表'
      }],
      accountCode: '',
      accountName: '',
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        }
      },
      mainTitle: '修改合同',
      subheading: '',
      isHousingInUnion : false,
      secDiscountOrSecIncreaseRate: '1',
      leaseAheadPayDayType: '1',
      secValue: '',
      trdValue: '',
      enterpriseLoading: false,
      enterpriseList: [],
      signerNameLoading: false,
      signerNameList: [],
      yqPersonList: [],
      enterpriseCode: '',

      typeList: [
        {
          code: '商户租赁',
          name: '商户租赁'
        }, {
          code: '场地租赁',
          name: '场地租赁'
        }, {
          code: '工商地址注册',
          name: '工商地址注册'
        }, {
          code: '其它',
          name: '其它'
        }
      ],

      customSourceList: [
        {
          code: '自主招商',
          name: '自主招商'
        }, {
          code: '中介介绍',
          name: '中介介绍'
        }
      ],
      incrementalTimePoint: '',
      incrementalTimePointList: [],
      propertyIncrementalTimePointList: [],

      rentActiveNames: [],
      propertyActiveNames: [],
      rentDetailData: false,
      propertyDetailData: false,
      rentTotal1: 0,
      rentTotal2: 0,
      rentTotal1_1: 0,
      rentTotal2_1: 0,
      changeRentData: false,
      propertyTotal1: 0,
      propertyTotal1_1: 0,
      propertyTotal2: 0,
      propertyTotal2_1: 0,
      changePropertyData: false,

      billTypeList: [],
      formData: {
        leaseName: '',
        signerName: '',
        signerPhone: '',
        address: '',
        roomInfoArea: '',

        type: '',
        contractSignDate: '',
        contractStartDate: '',
        contractEndDate: '',
        propertyAheadPayDays: '',

        otherPayItemDetails: [
          {
            billType: '',
            payMoney: '',
            billStartTime: '',
            billEndTime: '',
            feeType: '其他',
            memo: ''
          }
        ],

        fellowPeopleName: '',           // 合同跟进人名称
        fellowPeopleCode: '',           // 合同跟进人code
        customSource: '',
        memo: ''

      },
      // 审批信息
      approveDialog: false,
      accountList: [],
      contractCode: '',
      approveAccountCode: '',
      digest: '',

      // 附件信息
      uploadHeaders: {
        token: bus.global.token,
        'yq-app-code': bus.global.yqCode,
      },
      uploadAction: api.uploadPdf,

      addBillTypeVisible: false,
      billTypeCode: '',
      billTypeName: '',
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.accountCode = bus.global.accountCode
    this.accountName = bus.global.accountName
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    let oneYearLateYear = year + 1
    let oneYearLateMonth = month
    let oneYearLateDate = ''
    if(strDate > 1){
      oneYearLateDate = strDate-1
    } else {
      oneYearLateMonth = month-1
      if (oneYearLateMonth < 10) {
        oneYearLateMonth= "0" + oneYearLateMonth
      }
      if( oneYearLateMonth === 0 ){
        oneYearLateMonth = 12
        oneYearLateYear = year
      }
      oneYearLateDate = new Date(oneYearLateYear, oneYearLateMonth, 0).getDate()
    }
    if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
      oneYearLateDate = "0" + oneYearLateDate;
    }
    // this.formData.contractStartDate = `${year}-${month}-${strDate}`
    // this.formData.contractSignDate = `${year}-${month}-${strDate}`
    // this.formData.contractEndDate = `${oneYearLateYear}-${month}-${strDate}`
    this.getYqPersonList()
    this.getOtherBillTypeList()
    // this.getOtherContractManagerByCode()
  },
  mounted () {},
  methods: {
    // 获取账单类型列表
    getOtherBillTypeList () {
      this.$axios.post(api.getOtherBillTypeList, {})
        .then(res => {
          this.billTypeList = res.data.data || []
          this.getOtherContractManagerByCode()
        })
        .catch(errorHandler("获取账单类型失败"));
    },
    // 选择房间类型
    changeBillType (item,e) {
      console.log(item,e)
      this.billTypeList.forEach(a =>{
        if (a.code === e){
          item.billType = a.name
        }
      })
      this.billTypeCode = e
      item.billTypeCode = e
    },
    // 添加房间类型弹窗
    wantAddBillType () {
      this.billTypeName = ''
      this.addBillTypeVisible = true
    },
    // 添加房间类型
    addBillType () {
      if (!this.billTypeName) {
        nError('请输入类型名称')
      }
      let typeList = []
      typeList.push(this.billTypeName)
      this.$axios.post(api.addOtherBillType, typeList)
        .then(res => {
          this.addBillTypeVisible = false
          nSuccess('添加成功')
          this.getOtherBillTypeList()
        })
        .catch(errorHandler('添加失败'))
    },
    // 删除房间类型
    deleteBillType (option) {
      this.$axios.post(api.deleteOtherBillTypeByCodes, [option.code])
        .then(res => {
          this.roomTypeCode = ''
          nSuccess('删除成功')
          this.getOtherBillTypeList()
        })
        .catch(errorHandler('删除失败'))
    },
    // 上传成功
    uploadContractSuccess (res) {
      let fileUrl = res.data
      this.formData.attachmentList.push(fileUrl)
      this.$refs.uploadContract.clearFiles()
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    // 删除pdf
    deleteAttachmentItem (index) {
      this.formData.attachmentList.splice(index, 1)
    },
    previewFile (url) {
      if (url.indexOf('.doc') === -1) {
        window.open(url, '_blank')
      } else {
        window.open('http://view.officeapps.live.com/op/view.aspx?src=' + url, '_blank')
      }
    },

    getOtherContractManagerByCode () {
      this.$axios.get(`${api.getOtherContractManagerByCode}/${this.currentCode}`, {})
        .then(res => {
          let data = res.data.data
          if (!data.attachmentList) {
            data.attachmentList = []
          }
          this.formData = data
          let billDeList = data.otherPayItemDetails || []
          billDeList.map(item =>{
            this.billTypeList.forEach(a =>{
              if (a.name == item.billType){
                item.billTypeCode = a.code
              }
            })
          })
        })
        .catch(errorHandler('获取合同失败'))
    },
    toCustomManagement () {
      this.$router.push({
        name: 'other-contract-management'
      })
    },

    // 签订人搜索
    enterpriseManagerMethod (query) {
      this.signerNameLoading = true;
      this.$axios.post(api.getEnterpriseManagerList, {
        enterpriseCode: this.enterpriseCode,
        searchKey: query || ''
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.signerNameLoading = false;
            let data = res.data.data
            this.signerNameList = data
          }
        })
        .catch(errorHandler('获取签订人失败'))
    },

    // 获取跟进人列表
    getYqPersonList () {
      this.$axios.post(api.getYqPersonList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.yqPersonList = data
          }
        })
        .catch(errorHandler('获取跟进人列表失败'))
    },

    otherItemValueChange (index) {
      if (this.formData.others[index].payMoney) {
        this.formData.others[index].payMoney = parseFloat(this.formData.others[index].payMoney).toFixed(2)
      } else {
        this.formData.others[index].payMoney = '0.00'
      }
    },


    // 增加其他费用
    addOtherItemLine () {
      let obj = {
        billType: '',
        payMoney: '',
        billStartTime: '',
        billEndTime: '',
        feeType: '其他',
        memo: ''
      }
      this.formData.otherPayItemDetails.push(obj)
    },

    // 删减其他费用
    removeOtherItemLine (index) {
      this.formData.otherPayItemDetails.splice(index, 1)
    },

    // 获取审批人员列表
    getAccountListByCode () {
      this.$axios.post(api.getAccountListByCode, {
        accountCode: this.accountCode
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data.length > 0) {
              data.map(v => {
                v._labelName = `${v.name} / ${v.actualName}`
              })
            }
            this.accountList = data
          }
        })
        .catch(errorHandler('获取审批人员列表失败'))
    },

    // 保存合同
    confirm () {
      if (!this.formData.leaseName) {
        nError("请输入乙方名称");
        return false;
      }
      if (!this.formData.signerName) {
        nError("请输入签订人姓名");
        return false;
      }
      if (!this.formData.address) {
        nError("请输入租赁地址");
        return false;
      }
      if (!this.formData.signerPhone) {
        nError("请输入签订人手机");
        return false;
      }
      let hasBillInfo = true
      this.formData.otherPayItemDetails.map(v => {
        if (!v.payMoney || !v.billStartTime || !v.billEndTime) {
          hasBillInfo = false
        }
      })
      if (!hasBillInfo) {
        nError("请输入完整的账单信息");
        return false;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name
        }
      })
      this.$axios.post(api.saveToUpdateOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('保存成功')
            this.toCustomManagement()
          }
        })
        .catch(errorHandler('保存失败'))
    },
    confirmAndApproval () {
      if (!this.formData.leaseName) {
        nError("请输入乙方名称");
        return false;
      }
      if (!this.formData.signerName) {
        nError("请输入签订人姓名");
        return false;
      }
      if (!this.formData.address) {
        nError("请输入租赁地址");
        return false;
      }
      if (!this.formData.signerPhone) {
        nError("请输入签订人手机");
        return false;
      }
      let hasBillInfo = true
      this.formData.otherPayItemDetails.map(v => {
        if (!v.payMoney || !v.billStartTime || !v.billEndTime) {
          hasBillInfo = false
        }
      })
      if (!hasBillInfo) {
        nError("请输入完整的账单信息");
        return false;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name
        }
      })
      this.formData.roomInfoSeat = this.formData.officeSeat
      this.$axios.post(api.saveToUpdateOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let contractCode = res.data.data
            if (contractCode) {
              this.contractCode = contractCode
              this.approveDialog = true
              nSuccess('保存成功')
            }
          }
        })
        .catch(errorHandler('保存失败'))

    },
    cancel () {
      this.toCustomManagement()
    },

    // 取消审批
    cancelApprove () {
      this.approveDialog = false
      this.approveAccountCode = ''
      this.digest = ''
    },

    // 提交审批
    confirmApprove () {
      let obj = {
        contractCode: this.contractCode,
        sponsorAccountCode: this.accountCode,
        sponsorAccountName: this.accountName,
        digest: this.digest,
        approveType: '4',
      }
      if (this.formData.status === '2') {
        obj.approveType = '5'
        this.$axios.post(api.submitReletOtherContractApprove, obj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('提交审批成功')
              this.toCustomManagement()
            }
          })
          .catch(errorHandler('提交审批失败'))
      } else {
        this.$axios.post(api.submitOtherContractApprove, obj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('提交审批成功')
              this.toCustomManagement()
            }
          })
          .catch(errorHandler('提交审批失败'))
      }
    },

  },
  watch: {
    // 'formData.signerCode': {
    //   handler(newName, oldName) {
    //     this.signerNameList.map(v => {
    //       if (v.code === this.formData.signerCode) {
    //         this.formData.signerName = v.name
    //         this.formData.signerPhone = v.phone
    //       }
    //     })
    //   },
    //   deep: true
    // },

  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  margin: 20px 0 10px 0;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 5px 0 10px;
  display: flex;
  justify-content: flex-start;
}
.form-line>div {
  width: 33%;
}
.line-text{
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 160px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
.contractAdd {
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}

.el-select .el-input .el-select__caret {
  height: 32px;
}
.el-input-group__append {
  padding: 0 5px!important;
  width: auto!important;
}
.el-input-group__prepend {
  padding: 0 5px!important;
  width: auto!important;
}
.discount-line {
  .el-input-group__append, .el-input-group__prepend {
    padding: 0 20px!important;
  }
}

.el-collapse-item__arrow {
  line-height: 48px!important;
}

.contractAdd {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--prefix .el-input__inner {
    padding: 0 0 0 30px;
  }
}

.approveDialogBox {
  text-align: left;
  .el-dialog {
    width: 800px;
  }
  .approveMainBox {
    text-align: center;
  }
  .approve_title {
    width: 120px;
  }
  .approveFlexBox {
    width: 500px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: flex-start;
  }
}

.rent-active {
  .el-range-editor--small {
    .el-range-separator {
      line-height: 30px;
      padding: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/OtherContractModify.vue